// extracted by mini-css-extract-plugin
export default {"inputStyle":"styles_inputStyle__76A1J"};